import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

export function useShouldShowSharingGoalFlow(): boolean {
	const {
		data: {
			skip,
			featureConfigs: { isSuperRecruiterFlowEnabled, isShareSlideUpEnabled },
		},
	} = usePsfSharePageData();
	const isMobile = useIsMobile();

	return !skip && isSuperRecruiterFlowEnabled && isShareSlideUpEnabled && isMobile;
}
